<div class="global"></div>